import { render, staticRenderFns } from "./contactUs.vue?vue&type=template&id=01d2f45f&scoped=true&"
import script from "./contactUs.vue?vue&type=script&lang=js&"
export * from "./contactUs.vue?vue&type=script&lang=js&"
import style0 from "./contactUs.vue?vue&type=style&index=0&id=01d2f45f&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d2f45f",
  null
  
)

export default component.exports